import { render, staticRenderFns } from "./Choise.vue?vue&type=template&id=1e6c1918&"
import script from "./Choise.vue?vue&type=script&lang=js&"
export * from "./Choise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports